import type {
  RegionalOverviewDiseaseRiskTechnician,
  RegionalOverviewV2Properties
} from 'querys/regional-overview/regional-overview.query.models';
import {
  ALL_FILTER_VALUE,
  RegionalOverviewFilterType,
  buildFilter,
  type Filter
} from '@features/regional-overview/regional-overview.models';
import i18n from 'i18next';
import { sortFilterOptionsByLabel } from '../filter.utils';
import { isAllOrEmpty } from './builders.utils';

const readTechnicians = (context?: Record<string, unknown>): RegionalOverviewDiseaseRiskTechnician[] =>
  (context?.technicians as RegionalOverviewDiseaseRiskTechnician[] | undefined) ?? [];

export const buildTechnicianFilter = <P extends RegionalOverviewV2Properties>(): Filter =>
  buildFilter<P>({
    type: RegionalOverviewFilterType.TECHNICIAN,
    defaultValue: [ALL_FILTER_VALUE],
    includeAllOption: true,
    translatable: false,
    sortOptions: options => sortFilterOptionsByLabel(options, option => option.labelKey, i18n.language),
    getValues: (_feature, context) => readTechnicians(context).map(technician => technician.id),
    matches: (feature, value, context) => {
      if (isAllOrEmpty(value)) return true;
      const propertyId = feature.properties?.values?.property_id;
      if (!propertyId) return false;
      const selection = new Set(value as string[]);
      return readTechnicians(context).some(technician => selection.has(technician.id) && technician.properties.includes(propertyId));
    }
  });
